<template>
  <v-dialog v-model="viewDialog" class="the-app-dialogs" persistent max-width="800px">
    <v-card>
      <v-layout row class="no-select not-printable" style="background-color:#09132f">
        <h3 id="dialog-title" class="text-uppercase px-3 pt-3" style="text-xs-center letter-spacing:2px">
          <v-layout align-center>
            <v-icon light x-large class="rgba(0,0,0,0.3)--text pb-1">attach_money</v-icon>
            <span class="px-3">{{ $t('View Promotion information') }}</span>
          </v-layout>
        </h3>
        <v-spacer />
        <v-card-actions>
          <v-btn fab icon dark @click="$emit('hidemodal')">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-actions>
      </v-layout>

      <v-card-title class="view-dialog-content grey lighten-3" id="printArea">
        <invoice-header class="only-for-print" />

        <v-layout column>
          <v-layout row wrap class="invoice-content">
            <v-flex xs12 sm12 :class="{ 'px-4': $vuetify.breakpoint.smAndUp }">
              <v-layout row wrap>
                <v-flex xs12 style="text-align: center" class="only-for-print" pb-3>
                  <strong>{{ $t('Promotion') }}</strong>
                </v-flex>

                <v-flex xs12 class="pb-3">
                  <div class="caption no-select">
                    {{ $t('Promotion Name') }}
                  </div>
                  <strong>{{ viewInfo.promo_name || '-' }}</strong>
                </v-flex>

                <v-flex xs4 class="pb-3">
                  <div class="caption no-select">{{ $t('Start Date') }}</div>
                  <strong v-if="viewInfo.promo_start_date">
                    {{ viewInfo.promo_start_date }}
                  </strong>
                  <strong v-else>-</strong>
                </v-flex>
                <v-flex xs8 class="pb-3">
                  <div class="caption no-select">{{ $t('End Date') }}</div>
                  <strong v-if="viewInfo.promo_end_date">
                    {{ viewInfo.promo_end_date }}
                  </strong>
                  <strong v-else>-</strong>
                </v-flex>

                <v-flex xs4 class="pb-3">
                  <div class="caption no-select">{{ $t('Customer Rule') }}</div>
                  <strong>{{ $t(viewInfo.promo_customer_rule) }}</strong>
                </v-flex>
                <v-flex v-if="viewInfo.promo_customer_rule === 'Group'" xs8 class="pb-3">
                  <div class="caption no-select">
                    {{ $t('Customer Group') }}
                  </div>
                  <strong v-for="(group, index) in viewInfo.promo_customer_group" :key="index">
                    <v-chip>{{ group }}</v-chip>
                  </strong>
                </v-flex>

                <v-flex xs12 class="pb-3">
                  <div class="caption no-select">{{ $t('Outlet') }}</div>
                  <strong v-for="(outlet, index) in viewInfo.promo_outlet" :key="index">
                    <v-chip>{{ outlet }}</v-chip>
                  </strong>
                </v-flex>

                <v-flex xs4 class="pb-3">
                  <div class="caption no-select">{{ $t('Product Rule') }}</div>
                  <strong>{{ $t(viewInfo.promo_product_rule) }}</strong>
                </v-flex>
                <v-flex v-if="viewInfo.promo_product_rule === 'Product Type'" xs8 class="pb-3">
                  <div class="caption no-select">{{ $t('Product Type') }}</div>
                  <strong v-for="(product, index) in viewInfo.promo_customer_product_type" :key="index">
                    <v-chip>{{ product }}</v-chip>
                  </strong>
                </v-flex>
                <v-flex v-else-if="viewInfo.promo_product_rule === 'Specific Products'" xs8 class="pb-3">
                  <div class="caption no-select">
                    {{ $t('Specific Product') }}
                  </div>
                  <strong v-for="(product, index) in viewInfo.specific_products" :key="index">
                    <v-chip>{{ product }}</v-chip>
                  </strong>
                </v-flex>
                <v-flex xs8 v-else>
                  <!-- I put this just to make a design uniform when promo_product_rule === 'All' -->
                </v-flex>

                <v-flex xs4 class="pb-3">
                  <div class="caption no-select">
                    {{ $t('Amount Rule Type') }}
                  </div>
                  <strong v-if="viewInfo.promo_rule_amount_or_quantity">
                    {{ $t(viewInfo.promo_rule_amount_or_quantity) }}
                  </strong>
                </v-flex>
                <v-flex xs8 class="pb-3">
                  <div class="caption no-select">{{ $t('Value') }}</div>
                  <strong>{{ viewInfo.promo_rule_value | currency }}</strong>
                </v-flex>

                <v-flex xs4 class="pb-3">
                  <div class="caption no-select">{{ $t('Reward Type') }}</div>
                  <strong>{{ $t(viewInfo.promo_reward_type) }}</strong>
                </v-flex>
                <v-flex xs8 class="pb-3">
                  <div class="caption no-select">{{ $t('Reward Value') }}</div>
                  <strong v-if="viewInfo.promo_reward_type === 'Get Discount'">
                    {{ viewInfo.promo_reward_value | percentage }}
                  </strong>
                  <strong v-else>{{ viewInfo.promo_reward_value | currency }}</strong>
                </v-flex>

                <v-flex xs12 class="pb-3">
                  <div class="caption no-select">{{ $t('Description') }}</div>
                  <strong v-html="lnToBr(viewInfo.promo_description) || '-'" />
                </v-flex>

                <invoice-footer
                  :showSignatureSection="false"
                  :accountantName="''"
                  :payerRecipientName="''"
                  :payerOrRecipient="''"
                  class="only-for-print"
                />
              </v-layout>
            </v-flex>
          </v-layout>
        </v-layout>
      </v-card-title>
      <v-divider light />

      <v-card-actions class="grey lighten-3 not-printable">
        <v-layout justify-end>
          <v-btn outline color="primary" @click="$emit('hidemodal')">
            {{ $t('Close') }}
          </v-btn>
          <v-btn color="primary" @click="printMe()">
            <v-icon :right="$vuetify.rtl" :left="!$vuetify.rtl">print</v-icon>
            {{ $t('Print') }}
          </v-btn>
        </v-layout>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import * as helpers from '@/mixins/helperFunctions.js'
import ignored from 'print-this'

export default {
  name: 'view-component',

  components: {
    invoiceHeader: () => import('@/views/_partials/invoiceHeader.vue'),
    invoiceFooter: () => import('@/views/_partials/invoiceFooter.vue')
  },

  props: {
    viewDialog: { type: Boolean, required: true }
  },

  data() {
    return {
      viewInfo: {
        promo_id: '',
        promo_name: '',
        promo_outlet: [],
        promo_start_date: '',
        promo_customer_rule: '',
        promo_end_date: '',
        promo_customer_group: [],
        promo_product_rule: '',
        promo_customer_product_type: [],
        specific_products: [],
        promo_rule_amount_or_quantity: 0,
        promo_reward_type: '',
        promo_reward_value: '',
        promo_description: '',
        promo_rule_value: ''
      }
    }
  },

  computed: {
    ...mapGetters({
      promotionInfo: 'promotions/getPromotionInfo',
      outletsList: 'outlets/getFullOutletsList',
      customerGroupsList: 'customersGroups/getFullGroupsList',
      productTypesList: 'productTypes/getFullProductTypesList',
      productListSalesList: 'products/getFullSaleProductsList'
    })
  },

  watch: {
    viewDialog: {
      immediate: false,
      handler() {
        if (this.viewDialog) {
          this.viewInfo.promo_id = this.promotionInfo.promotion.promo_id
          this.viewInfo.promo_name = this.promotionInfo.promotion.promo_name
          this.viewInfo.promo_outlet = this.promotionInfo.promotion.promo_outlet
          this.viewInfo.promo_start_date = this.promotionInfo.promotion.promo_start_date
          this.viewInfo.promo_customer_rule = this.promotionInfo.promotion.promo_customer_rule
          this.viewInfo.promo_end_date = this.promotionInfo.promotion.promo_end_date
          this.viewInfo.promo_customer_group = this.promotionInfo.promotion.promo_customer_group
          this.viewInfo.promo_product_rule = this.promotionInfo.promotion.promo_product_rule
          this.viewInfo.promo_customer_product_type = this.promotionInfo.promotion.promo_customer_product_type
          this.viewInfo.specific_products = []
          this.viewInfo.specific_products = this.promotionInfo.specific_products
          this.viewInfo.promo_rule_amount_or_quantity = this.promotionInfo.promotion.promo_rule_amount_or_quantity
          this.viewInfo.promo_reward_type = this.promotionInfo.promotion.promo_reward_type
          this.viewInfo.promo_rule_value = this.promotionInfo.promotion.promo_rule_value
          this.viewInfo.promo_reward_value = this.promotionInfo.promotion.promo_reward_value
          this.viewInfo.promo_description = this.promotionInfo.promotion.promo_description

          this.parseOutletStringToArray()
          if (this.viewInfo.promo_customer_rule === 'Group') {
            this.parseCustomerStringToArray()
          }

          if (this.viewInfo.promo_product_rule === 'Product Type') {
            this.parseProductTypeStringToArray()
          } else if (this.viewInfo.promo_product_rule === 'Specific Products') {
            this.parseSpecificProductStringToArray()
          }
        }
      }
    }
  },

  updated() {
    document.addEventListener('keyup', e => {
      // if the "ESC" button was pressed and this dialog is shown, hide it
      if (e.keyCode === 27 && this.viewDialog) {
        this.$emit('hidemodal')
      }
    })
  },

  mounted() {
    this.setOutletsList()
  },

  methods: {
    ...mapActions({
      setOutletsList: 'outlets/setFullOutletsList'
    }),

    parseOutletStringToArray() {
      this.viewInfo.promo_outlet = this.viewInfo.promo_outlet.split(',').map(item => {
        return parseInt(item)
      })
      this.getPromoOutletName(this.viewInfo.promo_outlet)
    },

    parseCustomerStringToArray() {
      this.viewInfo.promo_customer_group = this.viewInfo.promo_customer_group.split(',').map(item => {
        return parseInt(item)
      })
      this.getPromoCustomerGroupName(this.viewInfo.promo_customer_group)
    },

    parseProductTypeStringToArray() {
      this.viewInfo.promo_customer_product_type = this.viewInfo.promo_customer_product_type.split(',').map(item => {
        return parseInt(item)
      })
      this.getPromoProductTypeName(this.viewInfo.promo_customer_product_type)
    },

    parseSpecificProductStringToArray() {
      this.promotionInfo.specific_products = this.promotionInfo.specific_products.map(item => {
        return parseInt(item.product_id)
      })
      this.getPromoSpecificProductName(this.promotionInfo.specific_products)
    },

    getPromoOutletName(promoCardOutlet) {
      this.viewInfo.promo_outlet = []
      this.viewInfo.promo_outlet = this.outletsList
        .map(outlet => {
          let exist = false
          promoCardOutlet.forEach(f => {
            if (Object.values(outlet).indexOf(f) >= 0) {
              exist = true
            }
          })
          if (exist) {
            return outlet.text
          }
        })
        .filter(outlet => {
          return outlet != null
        })
    },

    getPromoCustomerGroupName(promoCustomerGroup) {
      this.viewInfo.promo_customer_group = []
      this.viewInfo.promo_customer_group = this.customerGroupsList
        .map(customerGroup => {
          let exist = false
          promoCustomerGroup.forEach(f => {
            if (Object.values(customerGroup).indexOf(f) >= 0) {
              exist = true
            }
          })
          if (exist) {
            return customerGroup.text
          }
        })
        .filter(outlet => {
          return outlet != null
        })
    },

    getPromoProductTypeName(promoProductType) {
      this.viewInfo.promo_customer_product_type = []
      this.viewInfo.promo_customer_product_type = this.productTypesList
        .map(productType => {
          let exist = false
          promoProductType.forEach(f => {
            if (Object.values(productType).indexOf(f) >= 0) {
              exist = true
            }
          })
          if (exist) {
            return productType.text
          }
        })
        .filter(outlet => {
          return outlet != null
        })
    },

    getPromoSpecificProductName(promoSpecificProduct) {
      this.viewInfo.specific_products = []
      this.viewInfo.specific_products = this.productListSalesList
        .map(specificProduct => {
          let exist = false
          promoSpecificProduct.forEach(f => {
            if (Object.values(specificProduct).indexOf(f) >= 0) {
              exist = true
            }
          })
          if (exist) {
            return specificProduct.text
          }
        })
        .filter(outlet => {
          return outlet != null
        })
    },

    lnToBr(str) {
      return helpers.newLineToBreakLine(str)
    },

    printMe() {
      helpers.doPrinting()
    }
  }
}
</script>

<style scoped>
.only-for-print {
  display: none;
}
</style>
